module.exports = "<svg id=\"07f05eec-456f-454e-8a92-b719350561d5\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 50 50\"><title>instagram</title><rect width=\"50\" height=\"50\"></rect><rect x=\"10.82\" y=\"10.07\" width=\"27.88\" height=\"27.88\" rx=\"6.46\" ry=\"6.46\" style=\"fill: #fff\"></rect><circle class=\"circle\" cx=\"25.5\" cy=\"24.01\" r=\"5.23\" style=\"fill: none;stroke-linecap: round;stroke-miterlimit: 10;stroke-width: 3px\"></circle><circle cx=\"34.22\" cy=\"15.44\" r=\"1.86\"></circle></svg>"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/instagram.svg
// module id = 504
// module chunks = 1